<template>
    <div class="caap my-6">
      

      <!-- Breadcrumbs -->
      <nav class="flex justify-between items-center px-3" aria-label="Breadcrumb">
            <div class="flex items-center">
            <button @click="goToMockExamHistory()" class="text-sm font-medium text-warm-gray-500 hover:text-warm-gray-400" aria-current="page">
                <ChevronDoubleLeftIcon class="flex-shrink-0 h-6 w-6" aria-hidden="true" />
            </button>
            </div>
            <div class="text-sm font-medium text-warm-gray-500">
            <span class="hidden md:block">Review Mock Exam</span>
            <span class="block md:hidden">Review Mock Exam</span>
            </div>
            <!-- FAQ Menu -->
            <QuestionMarkCircleIcon class="h-5 w-5 text-warm-gray-500 hover:text-warm-gray-400" aria-hidden="true" />
        </nav>
  
      <!-- Main Content -->
      <main class="max-w-full mx-auto py-8 px-4 sm:py-10 sm:px-6 lg:max-w-7xl lg:px-8">
      
        <div v-if="isLoading" class="mt-6 sm:mt-0 flex flex-col sm:py-6 sm:px-6 max-w-full mx-auto lg:max-w-7xl space-y-6">
            <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow overflow-hidden border-b border-gray-200 dark:border-gray-800 sm:rounded-lg bg-true-gray-200 dark:bg-true-gray-800 animate-pulse h-96">
                </div>
              </div>
            </div>
        </div>
        <div v-else-if="isUnavailable" class="mt-6 sm:mt-0 flex flex-col sm:py-6 sm:px-6 max-w-full mx-auto lg:max-w-7xl space-y-6">
            <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow overflow-hidden border-b border-gray-200 dark:border-gray-800 sm:rounded-lg bg-true-gray-200 dark:bg-true-gray-800 h-auto px-8 py-8">
  
                  <h1 class="text-xl text-true-gray-400 font-semibold">😅 Mock Exam Data Unavailable</h1>
                  <p class="text-true-gray-500 mt-4 pr-12">Our system cannot retreive the data for this Mock Exam. Please make sure that you took this exam after March 30, 2023 where the 'Mock Exam Explorer' feature was first released.</p>
                  <p class="text-true-gray-500 mt-4 pr-12">If you have any questions or concerns, please contact us via Email (support@skilltech.ph) or Facebook Messenger, whichever is more convenient.</p>
                </div>
              </div>
            </div>
        </div>
        <div v-else class="mt-1 sm:mt-0 flex flex-col sm:px-6 max-w-full mx-auto lg:max-w-7xl">
          <header v-if="!isSummaryHidden" class="bg-true-gray-800 rounded-lg">
            
            <!-- Heading -->
            <div class="flex flex-col items-start justify-between gap-x-8 gap-y-4 bg-true-gray-700/10 px-4 py-4 sm:flex-row sm:items-center sm:px-6 lg:px-8">
              <div>
                <div class="flex items-center gap-x-3">
                  <!-- <div class="flex-none rounded-full bg-green-400/10 p-1 text-green-400">
                    <div class="h-2 w-2 rounded-full bg-current" />
                  </div> -->
                  <h1 class="flex gap-x-3 text-base leading-7">
                    <span class="font-semibold text-white">Subject: {{ getSelectedSubjectName(this.exam.subject) }}</span>
                  </h1>
                </div>
                <div class="text-xs leading-6 text-true-gray-400">
                  <span>Started {{ moment(this.exam.time.start).startOf('minutes').fromNow() }}. </span>
                  <span>Passing score is {{this.subjects.find(e => e.id === this.exam.subject).exam.limits.passer}}% and the time limit is {{this.subjects.find(e => e.id === this.exam.subject).exam.limits.time/60}} minutes.</span>
                </div>
              </div>
              <div v-if="this.exam.result.toUpperCase() == 'FAILED'" class="order-first flex-none rounded-full bg-red-900 bg-opacity-50 px-4 py-1 text-lg font-medium text-red-500 border border-red-600 sm:order-none">Failed</div>
              <div v-else class="order-first flex-none rounded-full bg-green-900 bg-opacity-50 px-4 py-1 text-lg font-medium text-green-500 border border-green-600 sm:order-none">Passed</div>
            </div>
  
            <!-- Stats -->
            <div class="grid grid-cols-1 bg-gray-700/10 grid-cols-1 lg:grid-cols-4">
              <div class="border-t border-true-gray-600 py-6 px-4 sm:px-6 lg:px-8">
                <p class="text-sm font-medium leading-6 text-true-gray-400">Total Score</p>
                <p class="mt-2 flex items-baseline gap-x-2">
                  <span :class="[(this.exam.result.toUpperCase() == 'FAILED') ? 'text-red-300' : 'text-green-300', 'text-4xl font-semibold tracking-tight']">{{ this.exam.score }}%</span>
                </p>
              </div>
              <div class="border-t border-true-gray-700 py-6 px-4 sm:px-6 lg:px-8 border-l lg:border-l">
                <p class="text-sm font-medium leading-6 text-true-gray-400">Total Time Spent</p>
                <p class="mt-2 flex items-baseline gap-x-2">
                  <span class="text-4xl font-semibold tracking-tight text-white">{{ this.formatTime(this.exam.time.running) }}</span>
                  <!-- <span  class="text-sm text-gray-400">mins</span> -->
                </p>
              </div>
              <div class="border-t border-true-gray-700 py-6 px-4 sm:px-6 lg:px-8 border-l lg:border-l">
                <p class="text-sm font-medium leading-6 text-true-gray-400">Skillpoints Earned</p>
                <p class="mt-2 flex items-baseline gap-x-2">
                  <span class="text-4xl font-semibold tracking-tight text-white">{{ this.exam.skillpoints }}</span>
                  <!-- <span  class="text-sm text-gray-400">mins</span> -->
                </p>
              </div>
              <div class="border-t border-true-gray-700 py-6 px-4 sm:px-6 lg:px-8 border-l lg:border-l">
                <p class="text-sm font-medium leading-6 text-true-gray-400">Milestones Acheived</p>
                <p class="mt-2 flex items-baseline gap-x-2">
                  <div class="flex w-full justify-between space-x-2">
                    <div class="w-28 flex flex-col items-center">
                      <div :class="[(this.exam.milestones.includes('passer')) ? 'bg-blue-200' : 'bg-true-gray-700', 'mx-auto flex-grow-0 rounded-full w-12 h-12 p-3']">
                        <PaperClipIcon :class="[(this.exam.milestones.includes('passer')) ? 'text-blue-500' : 'text-true-gray-600', 'w-6 h-6']" />
                      </div>
                    </div>
                    <div class="w-28 flex flex-col items-center">
                      <div :class="[(this.exam.milestones.includes('speedrunner')) ? 'bg-purple-200' : 'bg-true-gray-700', 'mx-auto flex-grow-0 rounded-full w-12 h-12 p-3']">
                        <LightningBoltIcon :class="[(this.exam.milestones.includes('speedrunner')) ? 'text-purple-500' : 'text-true-gray-600', 'w-6 h-6']" />
                      </div>
                    </div>
                    <div class="w-28 flex flex-col items-center">
                      <div :class="[(this.exam.milestones.includes('master')) ? 'bg-yellow-200' : 'bg-true-gray-700', 'mx-auto flex-grow-0 rounded-full w-12 h-12 p-3']">
                        <FireIcon :class="[(this.exam.milestones.includes('master')) ? 'text-yellow-500' : 'text-true-gray-600', 'w-6 h-6']" />
                      </div>
                    </div>
                  </div>
                </p>
              </div>
              
              
              
            </div>
          </header>
          
          
          <div class="w-full flex flex-col sm:flex-row justify-center mt-8 mb-6">
            <button @click="isSummaryHidden = (isSummaryHidden) ? false : true" type="button" class="my-2 mx-2 justify-center inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              <IdentificationIcon class="w-4 h-4"/>
              <span class="text-xs sm:text-sm">{{ (isSummaryHidden) ? 'Show Exam Summary' : 'Hide Exam Summary' }} </span>
            </button>
            <button @click="viewType = (viewType == 'TIMELINE') ? 'QUESTIONNAIRE' : 'TIMELINE'" type="button" class="my-2 mx-2 justify-center inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              <SwitchHorizontalIcon class="w-4 h-4"/>
              <span class="text-xs sm:text-sm">{{ (viewType == 'TIMELINE') ? 'Switch to Questionnaire View' : 'Switch to Timeline View' }} </span>
            </button>
          </div>
  
          <!-- Timeline View -->
          <main v-if="viewType == 'TIMELINE'" class="text-white mb-28">
            <div class="mt-2 mb-6">
              <p class="text-sm leading-6 dark:text-true-gray-400 text-true-gray-600">
                <span class="font-bold">NOTE: </span>Below is a timeline of your mock exam wherein you'll see how long you answered each question. An 'OVER' label means you took a little bit more time to answer the question while 'HIGH' means you took too much time needed. Correctly answered items are indicated as green and incorrect answers are indicated as red. You can click each question to see more details.
              </p>
            </div>
            <ul>
              <li v-for="(data, i) in graphData" :key="i" class="flex items-center space-x-2">
                <div @click="showData(i)" :class="[(data.isCorrect) ? 'bg-green-600 dark:bg-green-500' : 'bg-red-600 dark:bg-red-500','text-center rounded-md my-1 py-1 px-2 text-sm cursor-pointer hover:opacity-70 whitespace-nowrap']">
                  Question {{ i+1 }}
                </div>
                <div class="z-0 h-5 bg-true-gray-200 dark:bg-true-gray-800 opacity-90" :style="`width: 100%`">
                  <div @click="showData(i)" :class="[(data.isCorrect) ? 'bg-green-600 dark:bg-green-500' : 'bg-red-600 dark:bg-red-500', 'cursor-pointer hover:opacity-70 z-30 h-5']" :style="`width: ${data.timePercentage}%`">
                    <div v-if="i > 0" class="h-5 flex items-center bg-true-gray-200 dark:bg-true-gray-800 pointer-events-none" :style="`width: ${(graphData[i-1].timePercentage/data.timePercentage)*100}%`">
                      <div v-if="data.isSkipped" class="text-xs text-yellow-400 pl-2 font-bold pointer-events-none">SKIPPED</div>
                    </div>
                  </div>
                </div>
                <div class="w-8 text-center rounded-md text-xs hover:opacity-70">
                  
                  <!-- <span>{{ graphData[i].userTookTime.toLocaleString() }}</span>
                  <span>/{{ timePerQuestion.toLocaleString() }}</span> -->
  
                  <div v-if="(graphData[i].userTookTime/1000) >= (timePerQuestion*2)" class="dark:text-red-400 text-red-700">HIGH</div>
                  <div v-else-if="(graphData[i].userTookTime/1000) > timePerQuestion" class="dark:text-purple-400 text-purple-700">OVER</div>
                  <div v-else-if="(graphData[i].userTookTime/1000) < (timePerQuestion/2)" class="dark:text-yellow-400 text-yellow-700">FAST</div>
                  <div v-else-if="(graphData[i].userTookTime/1000) <= timePerQuestion" class="dark:text-gray-400 text-gray-700">NORMAL</div>
                  
                  <!-- <div v-if="i == 0">
                    <div v-if="data.timePercentage > (timePerQuestion*2)" class="dark:text-pink-400 text-pink-700">HIGH</div>
                    <div v-else-if="data.timePercentage > timePerQuestion" class="dark:text-purple-400 text-purple-700">OVER</div>
                  </div>
                  <div v-else>
                    <div v-if="data.timePercentage - graphData[i-1].timePercentage > (timePerQuestion*2)" class="dark:text-pink-400 text-pink-700">HIGH</div>
                    <div v-else-if="data.timePercentage - graphData[i-1].timePercentage > timePerQuestion" class="dark:text-purple-400 text-purple-700">OVER</div>
                  </div> -->
                  
                </div>
                
              </li>
            </ul>
          </main> 
          
          <!-- Questionnaire View -->
          <main v-if="viewType == 'QUESTIONNAIRE'" class="max-w-full mx-auto px-1 sm:py-8 w-full space-y-4 mb-28">
        
            <!-- Stats -->
            <div id="stats" class="dark:border-true-gray-700 min-h-60 rounded-md mb-4 flex justify-between">
              <div class="flex dark:text-warm-gray-500 text-warm-gray-800 text-md items-center">
                <FlagIcon class="w-5 h-5 mr-1" />
                <p class="hidden sm:block ml-2 font-medium dark:text-warm-gray-500 text-warm-gray-800">
                  Question {{ questionnaireExplorerIndex + 1 }} out of {{ this.exam.questionnaire.length }}
                </p>
                <p class="block sm:hidden ml-2 font-medium dark:text-warm-gray-500 text-warm-gray-800 flex flex-nowrap">
                  {{ questionnaireExplorerIndex + 1 }} of {{ this.exam.questionnaire.length }}
                </p>
                
              </div>
              <div class="flex text-warm-gray-800 text-md items-center space-x-2">
                <!-- <div class="ml-2 font-medium text-warm-gray-800 flex items-center">
                  <div class="mr-3 flex items-center dark:text-warm-gray-500 text-warm-gray-700">
                    <ClockIcon class="ml-1 w-5 h-5 mr-1" />
                    {{ this.formatTime(this.exam.answers[questionnaireExplorerIndex].timeMark-this.exam.time.start) }}
                  </div>
                  <div class="flex items-center dark:text-warm-gray-500 text-warm-gray-700">
                    <ChartSquareBarIcon class="ml-1 w-5 h-5 mr-1" />
                    {{ this.exam.score }}%
                  </div>
                </div> -->
  
                <!-- <div class="text-white">
                  {{ this.exam.answers[questionnaireExplorerIndex].answer }}
                </div> -->
  
  
                <div v-if="this.exam.questionnaire[questionnaireExplorerIndex].isSkipped" class="text-yellow-800 font-bold bg-yellow-300 text-xs px-2 py-1 rounded">
                  SKIPPED
                </div>
  
  
                <div class="text-warm-gray-500 flex items-center space-x-1">
                  <!-- {{ exam.time.limit }} == {{ exam.questionnaire.length }} == -->
                  <!-- <span>{{graphData[questionnaireExplorerIndex].userTookTime/1000}} == {{ timePerQuestion }}</span> -->
                  <ClockIcon class="w-5 h-5 mr-1" />
                  <span>
                    {{ computeTimeDiff()}} <span class="hidden md:block">seconds</span>
                  </span>
                  <div v-if="(graphData[questionnaireExplorerIndex].userTookTime/1000) >= (timePerQuestion*2)" class="text-xs bg-red-800 px-2 py-1 rounded-full text-red-200">HIGH</div>
                  <div v-else-if="(graphData[questionnaireExplorerIndex].userTookTime/1000) > timePerQuestion" class="text-xs bg-purple-800 px-2 py-1 rounded-full text-purple-200">OVER</div>
                  <div v-else-if="(graphData[questionnaireExplorerIndex].userTookTime/1000) < (timePerQuestion/2)" class="text-xs bg-yellow-800 px-2 py-1 rounded-full text-yellow-200">FAST</div>
                  <div v-else-if="(graphData[questionnaireExplorerIndex].userTookTime/1000) <= timePerQuestion" class="text-xs bg-gray-800 px-2 py-1 rounded-full text-gray-200">NORMAL</div>
                  
  
                  <!-- <div v-if="questionnaireExplorerIndex == 0">
                    <div v-if="graphData[questionnaireExplorerIndex].timePercentage > (timePerQuestion*2)" class="text-xs bg-true-gray-800 px-2 py-1 rounded-full dark:text-pink-400 text-pink-700">HIGH</div>
                    <div v-else-if="graphData[questionnaireExplorerIndex].timePercentage > timePerQuestion" class="text-xs bg-true-gray-800 px-2 py-1 rounded-fulldark:text-purple-400 text-purple-700">OVER</div>
                  </div>
                  <div v-else>
                    <div v-if="graphData[questionnaireExplorerIndex].timePercentage - graphData[questionnaireExplorerIndex-1].timePercentage > (timePerQuestion*2)" class="text-xs bg-true-gray-800 px-2 py-1 rounded-full dark:text-pink-400 text-pink-700">HIGH</div>
                    <div v-else-if="graphData[questionnaireExplorerIndex].timePercentage - graphData[questionnaireExplorerIndex-1].timePercentage > timePerQuestion" class="text-xs bg-true-gray-800 px-2 py-1 rounded-full dark:text-purple-400 text-purple-700">OVER</div>
                  </div> -->
                </div>
  
              </div>
            </div>
  
            <!-- Question -->
            <div class="select-none text-left text-warm-gray-900 dark:text-warm-gray-300 rounded-md -space-y-px p-6 border-2 border-dashed border-warm-gray-300 dark:border-true-gray-700 whitespace-pre-line">
              <!-- <p class="mb-4 text-yellow-400">📌 From Subtopic: <strong>{{ getSelectedSubtopicName(this.exam.questionnaire[questionnaireExplorerIndex].subtopic) }}</strong></p> -->
              <!-- {{ this.exam.questionnaire[questionnaireExplorerIndex].question }} -->
              <div v-html="this.exam.questionnaire[questionnaireExplorerIndex].questionHtml" class="w-full"></div>
              <img v-if="this.exam.questionnaire[questionnaireExplorerIndex].hasImage" :src="this.exam.questionnaire[questionnaireExplorerIndex].imageUrl" class="lg:max-w-24 rounded-xl mx-auto my-2 mt-4">
            </div>
  
            <!-- Choices -->
            <div id="choices" class="select-none mt-4">
              <ul class="text-warm-gray-800 dark:text-warm-gray-400 text-left rounded-md shadow-sm -space-y-px">
                <li v-for="(choice, idX) in this.exam.questionnaire[questionnaireExplorerIndex].choices" :key="idX">
                  <button
                    :class="[ showSelected(choice.id), setBorder(idX), 'flex justify-between border border-warm-gray-300 dark:border-true-gray-700 relative shadow-sm px-5 py-4 cursor-pointer text-left focus:outline-none w-full disabled:cursor-auto']"
                  >

                    <div v-html="choice.choiceHtml" class="w-full"></div>
                    
                      <span v-if="choice.id == this.exam.questionnaire[questionnaireExplorerIndex].answer">
                        <CheckCircleIcon class="text-green-500 h-5 w-5" />
                      </span>
                      <span v-else>
                        <XCircleIcon class="text-red-500 h-5 w-5" />
                      </span>
                    
                  </button>
                </li>
              </ul>
            </div>
  
            <!-- Action Buttons -->
            <nav class="mt-6 flex justify-between space-x-4">
              
  
              <button
                :disabled="questionnaireExplorerIndex == 0"
                @click="questionnaireExplorerIndex--, resetExplanations()"
                class="disabled:opacity-50 w-full sm:w-auto space-x-4 flex flex-inline justify-center items-center disabled:cursor-auto p-4 sm:px-5 shadow-sm border border-warm-gray-300 dark:border-true-gray-700 shadow-sm font-medium rounded-md text-warm-gray-700 dark:text-warm-gray-400 bg-white dark:bg-true-gray-800 hover:bg-warm-gray-100 dark:hover:bg-true-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Previous
                <!-- <ChevronDoubleRightIcon class="h-5 w-5 dark:text-warm-gray-400 text-warm-gray-500 ml-1"/> -->
              </button>
              
  
              <button
                :disabled="questionnaireExplorerIndex == this.exam.questionnaire.length-1"
                @click="questionnaireExplorerIndex++, resetExplanations()"
                class="disabled:opacity-50 w-full sm:w-auto space-x-4 flex flex-inline justify-center items-center disabled:cursor-auto p-4 sm:px-5 shadow-sm border border-warm-gray-300 dark:border-true-gray-700 shadow-sm font-medium rounded-md text-warm-gray-700 dark:text-warm-gray-400 bg-white dark:bg-true-gray-800 hover:bg-warm-gray-100 dark:hover:bg-true-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Next
                <!-- <ChevronDoubleRightIcon class="h-5 w-5 dark:text-warm-gray-400 text-warm-gray-500 ml-1"/> -->
              </button>
  
  
            </nav>
  
            <div class="flex flex-col justify-center items-center mt-12">
            <!-- <div v-if="false" class="flex flex-col justify-center items-center mt-12"> -->
              <button 
                v-if="!isWaitingForExplanation"
                @click="explainAnswer(this.$route.params.subtopic, questionnaire[exam.index])" :disabled="isWaitingForExplanation" type="button" class="my-2 disabled:opacity-50 w-full sm:w-auto space-x-4 flex flex-inline justify-center items-center disabled:cursor-auto p-4 sm:px-5 shadow-sm shadow-sm font-medium rounded-md focus:outline-0 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 hover:opacity-75 text-white">
                <span>Show Explanation</span>
              </button>
              <div v-else class="my-2 disabled:opacity-50 w-full sm:w-auto flex flex-inline justify-center items-center disabled:cursor-auto p-4 sm:px-5 shadow-sm shadow-sm font-medium rounded-md focus:outline-0 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 hover:opacity-75 text-white">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Please wait... </span>
              </div>
              <div v-if="answerExplanation" class="my-4 mx-auto flex max-w-screen-sm items-center justify-center">
                <div class="h-auto w-full rounded-md bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 p-1">
                  <div class="flex h-full w-full items-center justify-center bg-gray-800 back px-4 py-4">
                    <div class="text-sm text-white space-y-4">
                      <!-- {{ answerExplanation }} -->
                      <p v-for="parag,i  in answerExplanationArr" :key="i">
                        {{ parag }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="flex justify-center text-sm text-white text-warm-gray-700 dark:text-warm-gray-300 items-center space-x-2">
                <div>Powered by</div>
                <div class="h-4 -mt-1">
                  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 118 32" class="h-5" data-new="" aria-hidden="true" data-v-069f367b=""><g fill="currentColor" data-v-069f367b=""><path d="m36.7 15.4c0 5.2 3.4 8.9 8 8.9s8-3.6 8-8.9-3.4-8.9-8-8.9-8 3.7-8 8.9zm13 0c0 3.7-2 6.2-4.9 6.2s-4.9-2.4-4.9-6.2 2-6.2 4.9-6.2 4.9 2.4 4.9 6.2z"></path><path d="m61.4 24.3c3.5 0 5.5-3 5.5-6.6s-2-6.6-5.5-6.6c-1.6 0-2.8.6-3.6 1.6v-1.3h-2.9v16.9h2.9v-5.6c.8.9 2 1.6 3.6 1.6zm-3.7-6.9c0-2.4 1.3-3.7 3.1-3.7 2.1 0 3.2 1.6 3.2 4s-1.1 4-3.2 4c-1.8 0-3.1-1.3-3.1-3.6z"></path><path d="m74.8 24.3c2.5 0 4.5-1.3 5.4-3.5l-2.5-.9c-.4 1.3-1.5 2-2.9 2-1.8 0-3.1-1.3-3.4-3.5h8.8v-1c0-3.5-1.9-6.2-5.6-6.2-3.5 0-6 2.9-6 6.6 0 3.8 2.6 6.5 6.2 6.5zm-.2-10.7c1.8 0 2.7 1.2 2.7 2.6h-5.8c.5-1.7 1.6-2.6 3.1-2.6z"></path><path d="m82.4 24h2.9v-7.4c0-1.8 1.3-2.8 2.6-2.8 1.6 0 2.2 1.1 2.2 2.7v7.5h2.9v-8.3c0-2.7-1.6-4.5-4.2-4.5-1.6 0-2.8.7-3.5 1.6v-1.3h-2.9z"></path><path d="m101.4 6.8-6.5 17.2h3l1.5-3.9h7.4l1.5 3.9h3.1l-6.5-17.2zm1.7 3.4 2.7 7.2h-5.4z"></path><path d="m116.4 6.8h-3.1v17.2h3.1z"></path><path class="a-icon--logo-text-logo" d="m29.7 13.1c.4-1.1.5-2.2.4-3.3s-.5-2.2-1-3.2c-.9-1.5-2.2-2.7-3.7-3.4-1.6-.7-3.3-.9-5-.5-.8-.8-1.7-1.5-2.7-2s-2.2-.7-3.3-.7c-1.7 0-3.4.5-4.8 1.5s-2.4 2.4-2.9 4c-1.2.3-2.2.8-3.2 1.4-.9.7-1.6 1.6-2.2 2.5-.9 1.5-1.2 3.2-1 4.9s.9 3.3 2 4.6c-.4 1.1-.5 2.2-.4 3.3s.5 2.2 1 3.2c.9 1.5 2.2 2.7 3.7 3.4 1.6.7 3.3.9 5 .5.8.8 1.7 1.5 2.7 2s2.2.7 3.3.7c1.7 0 3.4-.5 4.8-1.5s2.4-2.4 2.9-4c1.1-.2 2.2-.7 3.1-1.4s1.7-1.5 2.2-2.5c.9-1.5 1.2-3.2 1-4.9s-.8-3.3-1.9-4.6zm-12 16.8c-1.6 0-2.8-.5-3.9-1.4 0 0 .1-.1.2-.1l6.4-3.7c.2-.1.3-.2.4-.4s.1-.3.1-.5v-9l2.7 1.6v7.4c.1 3.5-2.7 6.1-5.9 6.1zm-12.9-5.5c-.7-1.2-1-2.6-.7-4 0 0 .1.1.2.1l6.4 3.7c.2.1.3.1.5.1s.4 0 .5-.1l7.8-4.5v3.1l-6.5 3.8c-1.4.8-3 1-4.5.6-1.6-.4-2.9-1.4-3.7-2.8zm-1.7-13.9c.7-1.2 1.8-2.1 3.1-2.6v.2 7.4c0 .2 0 .4.1.5.1.2.2.3.4.4l7.8 4.5-2.7 1.6-6.4-3.7c-1.4-.8-2.4-2.1-2.8-3.6s-.3-3.3.5-4.7zm22.1 5.1-7.8-4.5 2.7-1.6 6.4 3.7c1 .6 1.8 1.4 2.3 2.4s.8 2.1.7 3.3c-.1 1.1-.5 2.2-1.2 3.1s-1.6 1.6-2.7 2v-7.6c0-.2 0-.4-.1-.5 0 0-.1-.2-.3-.3zm2.7-4s-.1-.1-.2-.1l-6.4-3.7c-.2-.1-.3-.1-.5-.1s-.4 0-.5.1l-7.8 4.5v-3.1l6.5-3.8c1-.6 2.1-.8 3.3-.8 1.1 0 2.2.4 3.2 1.1.9.7 1.7 1.6 2.1 2.6s.5 2.2.3 3.3zm-16.8 5.6-2.7-1.6v-7.5c0-1.1.3-2.3.9-3.2.6-1 1.5-1.7 2.5-2.2s2.2-.7 3.3-.5c1.1.1 2.2.6 3.1 1.3 0 0-.1.1-.2.1l-6.4 3.7c-.2.1-.3.2-.4.4s-.1.3-.1.5zm1.4-3.2 3.5-2 3.5 2v4l-3.5 2-3.5-2z"></path></g></svg>
                </div>
              </div> -->
            </div>
  
          </main>
  
  
        </div>
          
      </main>
    </div>
  </template>
  
  <script>
  // Import firebase dependencies
  import firebase from "@/firebase/config";
  import "firebase/auth";
  import "firebase/firestore";
  import { upsertExplanationByQuestionId } from "@/firebase/explanationsController";
  import Logo from "@/components/Logo"
  const db = firebase.firestore();
  
  
  // Import UI dependencies
  import { FlagIcon, ChartSquareBarIcon, ClockIcon, ChevronDoubleLeftIcon, 
    IdentificationIcon, PaperClipIcon, LightningBoltIcon, FireIcon, ChevronDownIcon, SortAscendingIcon, QuestionMarkCircleIcon, PlusIcon, CursorClickIcon, CheckCircleIcon, XCircleIcon, SwitchHorizontalIcon } from "@heroicons/vue/solid";
  import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
  import moment from "moment";
  
  import { userService } from '@/utils/user';
  import { reviewerService } from '@/utils/reviewer';
  import { examService } from '@/utils/exam';
  import axios from "axios";
  
  const apiKey = process.env.VUE_APP_OPENAI_API_KEY;
  const client = axios.create({
      headers: {
        Authorization: "Bearer " + apiKey,
      },
  });

  // puting this code to switch bet. reviewer ID
  // Reviewer id in production is different in development
  let reviewerId = 'lite';
  if (window.location.hostname.includes('localhost') || window.location.hostname.includes('skilltech.team')) {
    reviewerId = 'tByhLcFSn6tAWLBt79GY';
  }


  
  export default {
    components: {
      SwitchHorizontalIcon, PaperClipIcon, LightningBoltIcon, FireIcon, FlagIcon, ChartSquareBarIcon, ClockIcon, ChevronDoubleLeftIcon, QuestionMarkCircleIcon, PlusIcon, CursorClickIcon, ChevronDownIcon, SortAscendingIcon, CheckCircleIcon, XCircleIcon, IdentificationIcon,
      Menu, MenuButton, MenuItem, MenuItems,
      Logo
    },
    data(){
      return {
        isWaitingForExplanation: false,
        answerExplanation: '',
        answerExplanationArr: [],
        isUnavailable: false,
        isSummaryHidden: false,
        subtopics: null,
        subjects: null,
        subject: null,
        user: null,
        isLoading: true,
        exam: null,
        graphData: [],
        moment: moment,
        timePerQuestion: null,
        selected: "all-subjects",
        viewType: 'QUESTIONNAIRE',
        questionnaireExplorerIndex: 0
      }
    },
    name: "Caap Mock Exam History",
    computed: {
      
    },
    // mounted() {
    //   firebase.auth().currentUser.getIdTokenResult()
    //     .then((tokenResult) => {
    //       (tokenResult.claims.caap) 
    //         ? this.caapPurchased = true 
    //         : this.$router.push({ path: "/reviewers" });
    //     });
    // },
    async created(){
      this.isLoading = true
  
      document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
        
      this.user = await this.fetchUser();
      if(!this.user.license || !this.user.license.exam_date) this.$router.push({ path: '/onboarding-caap' });

      this.subjects = await this.fetchSubjects()
      this.subtopics = await this.fetchSubtopics()
      
      try {
        let examId = this.$route.query.examId
        this.exam = await this.fetchExam(examId)
  
        console.log('this.exam', this.exam)
  
        let timestamp_of_feature_release = 1688130323917;
        if(this.exam.time.start < timestamp_of_feature_release){
          console.log("EXAM WAS FROM BEFORE THE MOCK EXAM EXPLORER WAS RELEASED.")
          this.isUnavailable = true;
        }else{
          this.computeTimes();
        }
        
      }catch (err){
        console.log(err)
        this.isUnavailable = true;
      }
      this.isLoading = false
      
    },
    methods: {

    fetchUser(){
        return new Promise(async (resolve, reject) => {
            let id = firebase.auth().currentUser.uid
            firebase.firestore().collection("users").doc(id).get()
                .then(doc => {
                    let data = doc.data()
                    data.id = doc.id
                    resolve(data)
                })
                .catch((error) => {
                    console.error("Error getting user document:", error)
                    reject(error)
                });
        })
    },

    fetchExam(examId){
        return new Promise(async (resolve, reject) => {
            firebase.firestore().collection("lite_mock").doc(examId).get()
                .then(doc => {
                    let data = doc.data()
                    data.id = doc.id
                    resolve(data)
                })
                .catch((error) => {
                    console.error("Error getting user document:", error)
                    reject(error)
                });
        })
    },

    fetchSubtopics(){
        return new Promise(async (resolve, reject) => {
            firebase.firestore().collection("reviewers").doc(reviewerId).collection("subtopics").get()
                .then((querySnapshot) => {
                    var subtopics = [];
                    querySnapshot.forEach((doc) => {
                        let data = doc.data()
                        data.id = doc.id
                        subtopics.push(data)
                    });
                    resolve(subtopics)
                    console.log(subtopics)
                })
                .catch((error) => {
                    console.error("Error getting subtopic data: ", error);
                    reject(error)
                })
        })
    },

    fetchSubjects(){
        return new Promise(async (resolve, reject) => {
            firebase.firestore().collection("reviewers").doc(reviewerId).collection("subjects").get()
                .then((querySnapshot) => {
                    var subjects = [];
                    querySnapshot.forEach((doc) => {
                        let data = doc.data()
                        data.id = doc.id
                        subjects.push(data)
                    });
                    resolve(subjects)
                    console.log(subjects)
                })
                .catch((error) => {
                    console.error("Error getting subtopic data: ", error);
                    reject(error)
                })
        })
    },
  
      goToMockExamHistory(){
        if(this.$route.query.fromCourse){
          this.$router.push({ path: `/lite` });
        }else{
          this.$router.push({ path: '/lite/history' })
        }
      },
  
      async explainAnswer(subtopic, questionnaire){
        this.isWaitingForExplanation = true;
  
        let uniqueQuestionId = `${subtopic}_${questionnaire.id}`
        console.log('UNIQUE ID:', uniqueQuestionId)
  
        // fetch the explanatinos collections if it already exists.
        // if yes, then display this explanation
        // if not, fetch for an explanation from OpenAI and then save it
        // store explanation in UI and display
  
        console.log("Checking for any stored explanation.")
        await db.collection("explanations").where("questionId", "==", uniqueQuestionId)
          .get()
          .then((querySnapshot) => {
            if(querySnapshot.size > 0){ 
              console.log("A stored explanation was found.")
              this.answerExplanation = querySnapshot.docs[0].data().text
              this.answerExplanation = this.answerExplanation.replace(/(?:\r\n|\r|\n)/g, '\n\n');
              this.answerExplanationArr = this.answerExplanation.split(/(?:\r\n|\r|\n)/g).filter(item => item !== '');
              this.isWaitingForExplanation = false;
            }else{
              console.log("A stored explanation was NOT found.")
              this.doItWithAi(questionnaire, uniqueQuestionId)
            }
              
          })
          .catch((error) => {
              console.log("Error getting documents: ", error);
          });
        
      },
  
      async doItWithAi (questionnaire, uniqueQuestionId) {
        console.log("Fetching explanation from AI.")
        let result = await this.fetchExplanationFromOpenAi(questionnaire.questionHtml, questionnaire.choices, questionnaire.answer)
        if(!result.isSuccess) return
        
        console.log("AI returned an explanation", result.data)
        this.answerExplanation = result.data
        this.answerExplanation = this.answerExplanation.replace(/(?:\r\n|\r|\n)/g, '\n\n');
        this.answerExplanationArr = this.answerExplanation.split(/(?:\r\n|\r|\n)/g).filter(item => item !== '');
  
        // Attempt to save the explanation
        let payload = {
          questionId: uniqueQuestionId,
          text: result.data
        }
        console.log("Storing explanation to DB: ", payload)
        await this.storeExplanation(payload)
  
        this.isWaitingForExplanation = false
      },
  
  
      async storeExplanation(payload){
        try {
          const result = await upsertExplanationByQuestionId(payload, { preserveVotes: true })
          if (result && result.id) {
            return true
          }
          return false
        } catch (error) {
          console.error("Error saving explanation: ", error)
        }  
      },
  
      async fetchExplanationFromOpenAi(q, c, a){
  
        const ans = c.filter( e=> e.id == a.toString())[0].choiceHtml
        
        let htmlStrippedQuestion = q.replace(/(<([^>]+)>)/gi, "");
        let htmlStrippedAnswer = ans.replace(/(<([^>]+)>)/gi, "");
  
        const params = {
          // prompt: `You are an Aircraft Mechanic in the Philippines. Question: "${q}". Answer: "${ans}". Explain why and show solution if math problem.`, // we should have different prompts for different topics
          // prompt: `You are an Aircraft Mechanic in the Philippines. Question: "${q}". Answer: "${ans}". Explain why.`,
          prompt: `Question: "${htmlStrippedQuestion}". Answer: "${htmlStrippedAnswer}". Explain why in detail, with solution if possible.`, // we should have different prompts for different topics
          model: "text-davinci-003",
          max_tokens: 2000,
          n: 2,
          temperature: 0.5,
        };
  
        try {
          let result = await client.post("https://api.openai.com/v1/completions", params)
          console.log(result)
          if(this.isWaitingForExplanation){
              return {
                isSuccess: true,
                data: result.data.choices[0].text
              }
            }
        } catch (error) {
          console.log(err);
            this.isWaitingForExplanation = false;
            return {
              isSuccess: false
            }
        }
          
      },
  
      resetExplanations(){
        this.answerExplanation = '';
        this.answerExplanationArr = [];
        this.isWaitingForExplanation = false;
      },
  
      /**
       * Returns the HTML classes for the border of the choices container.
       * If first choice, set the top border as curved
       * If last choice, set the bottom border as curved
       * @NOTE: Utility function for UI
       * @TODO: Check if can be converted into reusable library. Also used in Practice Exam.
       * -- Issue for TODO: Using this.questionnaire (Practice) instead of this.exam.questionnaire (Mock)
       */
       setBorder(i) {
        if (i == 0) { 
          return "rounded-tl-md rounded-tr-md" 
        } else if (i == this.exam.questionnaire[this.questionnaireExplorerIndex].choices.length - 1) {
          return "rounded-bl-md rounded-br-md";
        }
      },
  
      /**
       * Returns the corresponding HTML classes for the selected choice or otherwise
       * @NOTE: Utility function for UI
       * @TODO: Check if can be converted into reusable library. Also used in Practice Exam.
       * -- Issue for TODO: Using this.questionnaire (Practice) instead of this.exam.questionnaire (Mock)
       */
      showSelected(id) {
        // return (this.exam.answers[this.questionnaireExplorerIndex].answer.toString() == id.toString())
        return (this.exam.questionnaire[this.questionnaireExplorerIndex].userAnswer.toString() == id.toString())
          ? "bg-true-gray-100 dark:bg-true-gray-700"
          : "bg-white dark:bg-true-gray-800 hover:bg-true-gray-100 dark:hover:bg-true-gray-700";
      },
  
      /**
       * Format's a timestamp for UI display
       * @NOTE: Utility function.
       * @TODO: Convert into reusable library
       */
       formatTime(time) {
        let momentedTime = this.moment("2015-01-01").startOf("day").seconds(time);
        return this.moment(momentedTime).format("HH:mm:ss");
      },
  
  
      showData(i){
        this.questionnaireExplorerIndex = i;
        this.viewType = 'QUESTIONNAIRE';
      },
  
      computeTimeDiff(){
        var start = null;
        if(this.questionnaireExplorerIndex == 0){
          start = moment(this.exam.time.start);
        }else{
          start = moment(this.exam.questionnaire[this.questionnaireExplorerIndex-1].timeMark);
        }
        var end = moment(this.exam.questionnaire[this.questionnaireExplorerIndex].timeMark); // another date
        var duration = moment.duration(end.diff(start));
        var seconds = duration.asSeconds();
        return seconds;
        
      },
  
      computeTimes(){
        
        /**
         * For debugging only: 
         */
  
        // let s = moment(this.exam.time.start).format("MMMM Do YYYY - hh:mm:ss A")
        // let e = moment(this.exam.time.end).format("MMMM Do YYYY - hh:mm:ss A")
        // let t = moment(this.exam.time.start+(this.exam.time.limit*1000)).format("MMMM Do YYYY - hh:mm:ss A")
  
        // console.log('the time user started the exam: ', s);
        // console.log('the time user finished the exam: ', e);
        // console.log('the time user is allowed to take the exam: ', t);
  
        /**
         * End of debug
         */
  
        var timeLimitInMs = this.exam.time.start+(this.exam.time.limit*1000)
  
        var start = moment(this.exam.time.start); //todays date
        // var end = moment(this.exam.time.end); // another date
        var end = moment(this.exam.time.start+(this.exam.time.limit*1000)); 
        var duration = moment.duration(end.diff(start));
        var seconds = duration.asSeconds();
  
        this.exam.answers.forEach( (answer, i) => {
          let _data = {};
          _data.timeMark = answer.timeMark;
          // _data.timePercentage = ((answer.timeMark-this.exam.time.start)/(this.exam.time.end-this.exam.time.start))*100;
          _data.timePercentage = ((answer.timeMark-this.exam.time.start)/(this.exam.time.end-this.exam.time.start))*100;
          _data.isCorrect = (answer.answer.toString() == this.exam.questionnaire[i].answer.toString()) ? true : false;
          _data.isSkipped = answer.isSkipped;
          
          // time it took for the user to answer
          _data.userTookTime = (i == 0) ? (answer.timeMark - this.exam.time.start) : (answer.timeMark - this.exam.answers[i-1].timeMark);
          this.graphData.push(_data)
        });
  
        this.graphData.sort( (a, b) => {
          if (a.timePercentage > b.timePercentage) return 1
          if (b.timePercentage > a.timePercentage) return -1
          return 0; 
        })
  
        // this.timePerQuestion = this.exam.time.limit*1000/this.exam.answers.length;
        this.timePerQuestion = this.exam.time.limit/this.exam.questionnaire.length;
        console.log('this.timePerQuestion', this.timePerQuestion)
        
        // merge the user data with the questionnaire
        this.exam.answers.forEach( (e, i) => {
          this.exam.questionnaire[i].isSkipped = e.isSkipped;
          this.exam.questionnaire[i].timeMark = e.timeMark;
          this.exam.questionnaire[i].userAnswer = e.answer;
        })
  
        // sort via time mark
        this.exam.questionnaire.sort( (a, b) => {
          if (a.timeMark > b.timeMark) return 1
          if (b.timeMark > a.timeMark) return -1
          return 0; 
        })
  
        this.subject = this.getSubject(this.exam.subject);
  
  
      },
      updateSelected(s){
        this.selected = s;
        // console.log("this.selected has changed to: => ", this.selected)
      },
      getSubject(subject_id){
        return this.subjects.filter( e => { return (e.id == subject_id) })[0]
      },
      getSelectedSubtopicName(subtopic_id){
        if(this.subtopics == null) return
        return ( subtopic_id == "all-subjects") ? "All Subjects" : this.subtopics.filter( e => { return (e.id == subtopic_id) })[0].name
      },
      getSelectedSubjectName(subject_id){
        if(this.subjects == null) return
        return ( subject_id == "all-subjects") ? "All Subjects" : this.subjects.filter( e => { return (e.id == subject_id) })[0].name
      },
      computeRating(score, time_running, time_limit){
        /*
          Ratings are computed by following a 50:50 ratio between your recorded Score and Time Left Percentage.
  
          For Example:
          Username: Tony Stark
          Subject: Spelling
          Total No. of Items: 75 Items
          Time Limit: 15 minutes (900 seconds)
  
          Mock Exam Score: 69 out of 75 [ 92% ]
          Time Consumed: 7 minutes (420 seconds)
          Time Left: 8 minutes (480 seconds) [ 53.33% of the time limit ]			  
  
          Rating 	= [ 50% of Score Percentage ] + [ 50% of Time Left Percentage ]
                  = [ 50% x 92% ] + [ 50% x 53.33% ]
                  = [ 46% ] + [ 26.66% ]
                  = 72.66%
        */
  
        let time_consumed = time_running;
        let time_left = time_limit - time_consumed;
        let time_left_percent = (time_left/time_limit)*100
        var rating = ( (score/2) + (time_left_percent/2) ).toFixed(2)
        return rating
      },
  
      // formatTime(time) {
      //   let momentedTime = this.moment("2015-01-01").startOf("day").seconds(time);
      //   return this.moment(momentedTime).format("HH:mm:ss");
      // },
    }
  };
  </script>